import { IItem } from '@checkout/items';
import * as React from 'react';
import { Fragment } from 'react';
import { connect } from 'react-redux';
import { ProductItem } from '..';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { addLineItemRequest, removeLineItemRequest } from './../../../reducers/checkout';
import * as Styles from './ProductsList.scss';

interface IOwnProps {
  items: IItem[];
  readOnly?: boolean;
  giftWrapProductId?: string;
}

interface IConnectetDispatchProps {
  increaseQuantity: typeof addLineItemRequest;
  decreaseQuantity: typeof removeLineItemRequest;
}

type Props = IOwnProps & IConnectetDispatchProps;

class ProductsList extends React.Component<Props, {}> {
  render() {
    const { items, increaseQuantity: increase, decreaseQuantity: decrease, readOnly, giftWrapProductId } = this.props;

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <div className={Styles.list}>
            {items && items.length > 0 && (
              <Fragment>
                {items.map(item => <ProductItem
                  key={item.item}
                  isGiftWrapProduct={item.item === giftWrapProductId}
                  urlPrefix={checkoutContextConfig.ui.productItem.productUrlPrefix}
                  item={item}
                  increaseQuantity={increase}
                  decreaseQuantity={decrease}
                  readOnly={readOnly}
                />)}
              </Fragment>
            )}
          </div>
      ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default connect<undefined, IConnectetDispatchProps>(
  undefined,
  {
    increaseQuantity: addLineItemRequest,
    decreaseQuantity: removeLineItemRequest,
  }
)(ProductsList);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/ProductsList/ProductsList.tsx